module.exports = __webpack_public_path__ + "2dea0576b6908ef05ac4096ce81fdb72.svg";